import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


/*
 * Ideas:
 * - Use `width` on the side panel container so that it doesn't get stretched by the reset button when it appears
 *   - eg. 20% looks good (that's 20% of the parent div), but you can experiment
 * - Use `opacity` on the non-active stage labels so they look less prominent than the active one
 * - Use `cursor: pointer` on the buttons so the mouse changes to a hand / clickable icon instead of just a normal pointer
 *   - Tip: look up `cursor css` to see all the options, they are really handy for the finishing touch on your work
 * - Maybe instead of having the reset button on the right, it could replace the 2 buttons underneath the timer instead
 *   - (you only need those 2 if Pomodoro is running, so if reset is showing up, you can get rid of them temporarily)
 * - The `transition` on the buttons is really cool, you can experiment with it in other areas too
 *   - Basically it lets you slowly transition most CSS properties whenever they happen to change
 *   - so you can even do it on `width`, `opacity` etc.
 */